import useActionsNewsTipAdvancedForm from './useActionsNewsTipAdvancedForm'

export default useActionsNewsTipAdvancedForm
